export default __webpack_public_path__ + "static/media/question-img.c4453095.png";